export default __webpack_public_path__ + "static/media/shortbreadBiscuits.105f1cbf.jpeg";